module.exports = __webpack_public_path__ + "img/sd.5f3e05eb.png";